import {formatDateToBR, formatHoursToBRWithoutSeconds} from "../../../../../utils/time";
import {capitalizeWords, formatCNPJ, formatCPF} from "../../../../../utils/utils";
import {SETableColumnsProps} from "../../../../components/SETable";

export const tableColumns: SETableColumnsProps[] = [
    {
        id: 'data',
        label: 'Data',
        width: 50,
        customField: formatDateToBR,
    },
    {
        id: 'fim',
        label: 'Hora',
        width: 50,
        customField: formatHoursToBRWithoutSeconds,
    },
    {
        id: 'administrador',
        label: 'Nome',
        minWidth: 100,
        customField: (administrador: any) => capitalizeWords(administrador?.nome),
    },
    {
        id: 'cpf',
        label: 'CPF',
        minWidth: 100,
        customField: formatCPF,
    },
    {
        id: 'empreendedor',
        label: 'CNPJ',
        minWidth: 100,
        customField: (empreendedor: any) => formatCNPJ(empreendedor?.cnpj),
    },
    {
        id: 'uf',
        label: 'UF',
        customField: (uf: any) => uf?.sigla,
        minWidth: 40,
        align: 'center',
        cellStyle: {
            display: 'flex',
            justifyContent: 'center'
        }
    },
    {
        id: 'cidade',
        label: 'Cidade',
        customField: (cidade: any) => cidade?.nome,
    },
    {
        id: 'tempoLogado',
        label: 'Tempo acesso',
        minWidth: '120px',
        align: "center"
    },
];